import { BasicApplicationService } from '../../../../../shared/services/BasicApplicationService';

export class AppApplicationService extends BasicApplicationService<MglModularSystemV2AppDefinition> {

	public isYoungGenerationRate(rate: string): boolean {
		const youngGenerationRates = ["J1", "48", "E17", "47", "EN1", "29", "E1", "23", "R1", "42"];
		if (youngGenerationRates.indexOf(rate) > -1) {
			return true;
		} else {
			return false;
		}
	}

	public isPredate(rate: string): boolean {
		const preDateRates = ["EN1", "EN2", "EN4"];
		if (preDateRates.indexOf(rate) > -1) {
			return true;
		} else {
			return false;
		}
	}

}
